//create a historyJobpostCard
import React, { useState } from "react";
import {
  AiOutlineClockCircle,
  AiOutlineComment,
  AiOutlineHistory,
  AiOutlineSolution,
  AiOutlineUser,
} from "react-icons/ai";
import { TbBriefcase2 } from "react-icons/tb";
import { GoCalendar, GoDotFill } from "react-icons/go";
import { PiDotsThreeBold } from "react-icons/pi";
// import { PieChart } from "react-minimal-pie-chart";
import { useStores } from "../../../store";
import { toJS } from "mobx";
import ApplicantLabelPopup from "../../recruiter/Resume/applicant_labelPopup";
import JobShare from "../../recruiter/Components/Job";
import { getDomainForWhiteLabeling } from "../../../services/white_label";
// import DropdownMenu from "../../reusble_components/dropDown";
import { useObserver } from "mobx-react";
import { Menu } from "../../reusble_components/dropDown";
import { useNavigate } from "react-router-dom";
import { IoIosArrowDropright } from "react-icons/io";
import smallLogo from "../../../assests/smallLogo.png";
import { IoShareSocialOutline } from "react-icons/io5";
import { GrDocumentUser } from "react-icons/gr";
import { HiOutlineMail } from "react-icons/hi";
// import { Link } from "react-router-dom";

const icons = [
  <HiOutlineMail
    name="mail"
    className="md:border rounded-md text-[30px] p-[5px] justify-between text-[#FF6B00] md:text-black border-primary"
  />,
  <IoShareSocialOutline
    name="share"
    className=" md:border rounded-md text-[30px] p-[5px] justify-between text-[#FF6B00] md:text-black border-primary"
  />,
  // <AiOutlineTag
  //   name="tag"
  //   className="border rounded-md text-[30px] p-[5px] border-[#ff6b00]"
  // />,
  <PiDotsThreeBold
    name="menu"
    className=" md:border rounded-md text-[30px] p-[5px] justify-between rotate-90 text-[#FF6B00] md:text-black border-primary "
  />,
];

const StatusAndButtons = ({ buttonLabels, status, verifiedStatus }) => {
  // console.log(buttonLabels);
  return (
    <div className="flex flex-col gap-2 ml-0 items-start">
      {`${status}` === "true" && verifiedStatus === 0 ? (
        <div className=" flex items-center gap-1 text-yellow">
          <GoDotFill className="text-xs font-medium" />
          <h1>Under Review</h1>
        </div>
      ) : // <li className="text-[#20BF55]"></li>
      `${status}` === "true" ? (
        <div className=" flex items-center gap-1 text-[#20BF55]">
          <GoDotFill className="text-xs font-medium" />
          <h1>Active</h1>
        </div>
      ) : // <li className="text-[#20BF55]"></li>
      `${status}` === "false" ? (
        <div className=" flex items-center gap-1 text-red-500">
          <GoDotFill className="text-xs font-medium" />
          <h1>Closed</h1>
        </div>
      ) : (
        // <li className="text-red-500">Closed</li>
        <div className=" flex items-center gap-1 text-yellow">
          <GoDotFill className="text-xs font-medium" />
          <h1>Pending</h1>
        </div>
        // <li className="text-yellow-500">Pending</li>
      )}
      <div className="hidden md:flex flex-wrap justify-start gap-2">
        {buttonLabels?.map((label, index) => (
          <button
            key={index}
            className="border rounded-lg cursor-default bg-[#DCDCDC] text-xs text-[#808080] h-7 px-4"
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

const JobDetails = ({
  cardType,
  interviewType,
  interviewLevel,
  questions,
  postedOn,
  workMode,
  experience,
  salary,
  cutOff,
  job,
}) => {
  // Function to get the appropriate icon based on card type and icon name
  const getIconByCardType = (cardType, iconName) => {
    switch (cardType) {
      case "jobPostCard":
        switch (iconName) {
          case "1":
            return (
              <AiOutlineClockCircle className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          case "2":
            return (
              <AiOutlineUser className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          // case "3":
          //   return (
          //     <LuIndianRupee className="text-[#858585] md:text-base text-sm lg:text-lg" />
          //   );
          case "4":
            return (
              <TbBriefcase2 className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          default:
            return null;
        }
      case "interviewCard":
        switch (iconName) {
          case "1":
            return (
              <AiOutlineComment className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          case "2":
            return (
              <AiOutlineSolution className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          case "3":
            return (
              <GoCalendar className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          case "4":
            return (
              <AiOutlineHistory className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          default:
            return null;
        }
      case "mcqCard":
        switch (iconName) {
          case "1":
            return (
              <AiOutlineComment className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          // case "2":
          //   return <AiOutlineSolution className="text-[#858585] md:text-base text-sm lg:text-lg" />;
          case "3":
            return (
              <GoCalendar className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          // case "4":
          //   return <AiOutlineHistory className="text-[#858585] md:text-base text-sm lg:text-lg" />;
          default:
            return null;
        }
      case "resumeCard":
        switch (iconName) {
          // case "1":
          //   return <AiOutlineSolution className="text-[#858585] md:text-base text-sm lg:text-lg" />;
          // case "2":
          //   return <PiIdentificationCardThin className="text-[#858585] md:text-base text-sm lg:text-lg" />;
          case "1":
            return (
              <GoCalendar className="text-[#858585] md:text-base text-sm lg:text-lg" />
            );
          default:
            return null;
        }
      default:
        return null;
    }
  };

  // Function to get the label by card type (example function, replace with actual logic)
  const getLabelByCardType = (cardType, iconName) => {
    switch (cardType) {
      case "jobPostCard":
        switch (iconName) {
          case "1":
            return "Posted on:";
          case "2":
            return "Experience:";
          case "3":
            return "Package:";
          case "4":
            return "Mode:";
          default:
            return null;
        }
      case "interviewCard":
        switch (iconName) {
          case "1":
            return "Total Question:";
          case "2":
            return "Type of Interview:";
          case "3":
            return "Interview created on:";
          case "4":
            return "Level of Interview:";
          default:
            return null;
        }
      case "mcqCard":
        switch (iconName) {
          case "1":
            return "Total Question:";
          case "2":
            return "Cut off:";
          case "3":
            return "Test created on:";

          default:
            return null;
        }
      case "resumeCard":
        switch (iconName) {
          // case "1":
          //   return "Sorting job post:";
          // case "2":
          //   return "Id:";
          case "1":
            return "Sorted on:";
          default:
            return null;
        }
      default:
        return null;
    }
  };
  const getValueByCardType = (cardType, iconName) => {
    switch (cardType) {
      case "jobPostCard":
        switch (iconName) {
          case "1":
            return `${postedOn}`;
          case "2":
            return `${experience} years`;
          case "3":
            return `${salary} `;
          case "4":
            return `${
              window.innerWidth < 900
                ? workMode === "Work From Office"
                  ? "WFO"
                  : workMode === "Work From Home"
                    ? "WFH"
                    : workMode
                : workMode
            }`;
          default:
            return null;
        }
      case "interviewCard":
        switch (iconName) {
          case "1":
            return `${questions} Questions`;
          case "2":
            return `${
              job?.interviewId === 8 || job?.interviewId === 2
                ? "AI"
                : "Predefined"
            }`;
          case "3":
            return `${postedOn}`;
          case "4":
            return `${interviewLevel}`;
          default:
            return null;
        }
      case "mcqCard":
        switch (iconName) {
          case "1":
            return `${questions} Questions`;
          case "2":
            return `${cutOff}% `;
          case "3":
            return `${postedOn}`;

          default:
            return null;
        }
      case "resumeCard":
        switch (iconName) {
          // case "1":
          //   return "Ui Ux Designer";
          // case "2":
          //   return "qwertyuiopssdfghj";
          case "1":
            return `${postedOn}`;
          default:
            return null;
        }
      default:
        return null;
    }
  };

  return (
    <div className=" md:flex lg:flex flex flex-wrap md:gap-10 lg:gap-10 justify-start gap-[3%] md:pr-0 lg:pr-0 pr-0 whitespace-nowrap md:text-lg lg:text-lg text-sm">
      {" "}
      {cardType === "resumeCard" && (
        <p className="md:text-md lg:text-lg text-sm flex items-center gap-1">
          {" "}
          <GrDocumentUser className="text-[#858585] md:text-lg text-base lg:text-lg" />{" "}
          <h1 className="md:text-sm lg:text-base text-xs">
            {/* {getValueByCardType(cardType, iconNumber.toString())} */}
            {job?.name ? job?.name : "-"}{" "}
          </h1>
        </p>
      )}
      {[1, 2, 3, 4].map((iconNumber) => (
        <div key={iconNumber}>
          <div className="flex flex-row items-center gap-1 md:text-lg lg:text-lg text-sm">
            {cardType === "mcqCard" && iconNumber === 2 ? null : (
              <>
                {getIconByCardType(cardType, iconNumber.toString())}
                {/* <h1 className="text-[#969696]">
                  {getLabelByCardType(cardType, iconNumber.toString())}
                </h1> */}
                <h1 className="md:text-sm  lg:text-base text-xs text-[#000000]">
                  {getValueByCardType(cardType, iconNumber.toString())}
                </h1>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
const IconButtons = ({
  status,
  job,
  onClick,
  cardType,
  labels,
  label,
  id,
  handleNavigation,
}) => {
  const { LabelStore, PopupStore, RecuiterStore, CommonStore, UserStore } =
    useStores();
  const [show, setShow] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [MenuId, setMenuId] = useState("");
  const navigate = useNavigate();

  const [isPopupVisible, setIsPopUpVisible] = useState(false);
  const [moreSettings, setMoreSettings] = useState("");
  const typeOfCard = cardType;
  const recuiterId = UserStore?.userDetails?._id;

  const hr = label === "HR Interview" ? true : false;

  const interviewId = hr ? 8 : 11;

  const jobPostLink =
    getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://reaidy.io/job/${id}`
      : `https://${getDomainForWhiteLabeling()}/jobpost/${id}`;
  const interviewLink =
    getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://user.reaidy.io/interview-creation/${interviewId}?meetingid=${id}`
      : `https://${getDomainForWhiteLabeling()}/share?page=interview_invitation&id=${id}`;
  const mcqLink =
    getDomainForWhiteLabeling() === "app.reaidy.io"
      ? `https://user.reaidy.io/mcq-test/${id}`
      : `https://${getDomainForWhiteLabeling()}/dashboard/mocktest?mocktestId=${id}&recruiterId=${recuiterId}`;
  const clientmcqLink = `https://${getDomainForWhiteLabeling()}/share/mcq-applicants?mocktestId=${id}`;
  const resumeLink = `https://${getDomainForWhiteLabeling()}/company/resumescore/${id}`;
  const clientresumeLink = `https://${getDomainForWhiteLabeling()}/company/resumescore/${id}`;

  const clientLink = `https://${getDomainForWhiteLabeling()}/share/job-applicants/${id}`;
  const clientInterviewLink = `https://${getDomainForWhiteLabeling()}/share/applicants?id=${id}&clientId=${
    RecuiterStore.clientId
  }`;

  const onShareClick = () => {
    setIsPopUpVisible(true);
  };

  const handlePopUpVisible = (value) => {
    setIsPopUpVisible(value);
  };
  const handleLink = () => {
    if (cardType === "jobPostCard") {
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
    if (cardType === "interviewCard") {
      let jobPostLink = interviewLink;
      let clientLink = clientInterviewLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
      // return {jobPostLink, clientLink};
    }
    if (cardType === "mcqCard") {
      // return mcqLink;
      let jobPostLink = mcqLink;
      let clientLink = clientmcqLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
    if (cardType === "resumeCard") {
      let clientLink = clientresumeLink;
      return { jobPostLink: resumeLink, clientLink: clientLink };
    }
    if (cardType === "mcqCard") {
      let jobPostLink = mcqLink;
      let clientLink = clientmcqLink;
      return { jobPostLink: jobPostLink, clientLink: clientLink };
    }
  };

  const handleDelete = () => {
    if (cardType === "interviewCard") {
      if (window.confirm("Are you sure you want to delete this interview?")) {
        RecuiterStore.deleteInterview(id);
        return setShow(false);
      }
    }
    if (cardType === "resumeCard") {
      if (window.confirm("Are you sure you want to delete this resume?")) {
        RecuiterStore.deleteResume(id);
        return setShow(false);
      }
    }
    if (cardType === "mcqCard") {
      if (window.confirm("Are you sure you want to delete this MCQ test?")) {
        RecuiterStore.deleteMockTest(id);
        return setShow(false);
      }
    } else {
      if (
        window.confirm(
          "All the applicants of this job post will be deleted. Are you sure you want to delete ?",
        )
      ) {
        RecuiterStore.deleteJobPost(id);
        return setShow(false);
      }
    }
  };

  const handleStatus = () => {
    if (cardType === "jobPostCard") {
      if (window.confirm("Do you want to change the status?")) {
        RecuiterStore.updateJobPostStatus(!status, id);
        return setShow(false);
      }
    }
    if (cardType === "interviewCard") {
      if (window.confirm("Do you want to change the status?")) {
        RecuiterStore.updateCompanyInvitation(!status, id);
        return setShow(false);
      }
    }
    if (cardType === "mcqCard") {
      if (window.confirm("Do you want to change the status?")) {
        RecuiterStore.updateMcqStatus(!status, id);
        return setShow(false);
      }
    }
  };
  const handleDetailsNavigation = () => {
    if (typeOfCard === "jobPostCard") {
      return navigate(`/company/jobpost/${id}`);
    }
    if (typeOfCard === "interviewCard") {
      console.log(job);
      RecuiterStore.setJob(job);
      PopupStore.setInterview(true);
    }
  };

  const handleSort = () => {
    navigate(`/company/resumescore/${id}?save=true`);
  };

  const editJobPost = () => {
    if (cardType === "jobPostCard") {
      // Reset progress state
      CommonStore.setProgress(0);

      // Set progress indicators based on job post data
      // Basic Info is always completed when editing
      CommonStore.setLabelActive(1, true);
      CommonStore.setLabelSkipped(1, false);

      // Mock Test section
      if (job?.mockTest) {
        CommonStore.setLabelActive(2, true);
        CommonStore.setLabelSkipped(2, false);
        CommonStore.setProgress(2); // Set progress to indicate completion
      } else {
        CommonStore.setLabelActive(2, false);
        CommonStore.setLabelSkipped(2, true);
      }

      // Technical Interview section
      if (job?.technicalInterview) {
        CommonStore.setLabelActive(3, true);
        CommonStore.setLabelSkipped(3, false);
        CommonStore.setProgress(3); // Set progress to indicate completion
      } else {
        CommonStore.setLabelActive(3, false);
        CommonStore.setLabelSkipped(3, true);
      }

      // HR Interview section
      if (job?.hrInterview) {
        CommonStore.setLabelActive(4, true);
        CommonStore.setLabelSkipped(4, false);
        CommonStore.setProgress(4); // Set progress to indicate completion
      } else {
        CommonStore.setLabelActive(4, false);
        CommonStore.setLabelSkipped(4, true);
      }

      // Task/Assessment section
      if (job?.assessment) {
        CommonStore.setLabelActive(5, true);
        CommonStore.setLabelSkipped(5, false);
        CommonStore.setProgress(5); // Set progress to indicate completion
      } else if (job?.codingInterview) {
        CommonStore.setLabelActive(5, true);
        CommonStore.setLabelSkipped(5, false);
        CommonStore.setProgress(5); // Set progress to indicate completion
      } else {
        CommonStore.setLabelActive(5, false);
        CommonStore.setLabelSkipped(5, true);
      }

      // Interview Settings section
      if (job?.customSettings) {
        CommonStore.setLabelActive(6, true);
        CommonStore.setLabelSkipped(6, false);
        CommonStore.setProgress(6); // Set progress to indicate completion
      } else {
        CommonStore.setLabelActive(6, false);
        CommonStore.setLabelSkipped(6, true);
      }

      // Other Platforms section
      // if (job?.otherPlatforms) {
      //   CommonStore.setLabelActive(7, true);
      //   CommonStore.setLabelSkipped(7, false);
      //   CommonStore.setProgress(7); // Set progress to indicate completion
      // } else {
      //   CommonStore.setLabelActive(7, false);
      //   CommonStore.setLabelSkipped(7, true);
      // }

      // Overview section
      CommonStore.setLabelActive(7, true);
      CommonStore.setLabelSkipped(7, false);
      CommonStore.setProgress(7); // Set progress to indicate completion

      navigate(`/company/job-post?id=${id}&isEdit=true`);
    }
    if (cardType === "resumeCard") {
      navigate(
        `/company/resumescore/${id}${
          job?.isSortingCompleted ? "" : "?save=true"
        }`,
      );
    }
    if (cardType === "interviewCard") {
      if (label === "HR Interview") {
        navigate(`/company/hr-interview?id=${id}&isEdit=true`);
      } else {
        navigate(`/company/technical-interview?id=${id}&isEdit=true`);
      }
    }
    if (cardType === "mcqCard") {
      navigate(`/company/mcq?id=${id}&isEdit=true`);
    }
  };
  return useObserver(() => (
    <div className="flex md:gap-6 lg:gap-6 gap-3 mt-3 items-center relative  md:mb-10 tc1:-mt-1 sm:-mt-0">
      {icons.map((icon, index) => (
        <div
          className="cursor-pointer relative"
          key={index}
          onClick={(e) => {
            if (icon.props.name === "share") {
              onShareClick();
            }

            if (icon.props.name === "menu") {
              setMoreSettings(id);
              setShow(true);
              setAnchorEl(e.currentTarget);
            }
            if (icon.props.name === "mail") {
              onClick();
            }

            if (cardType === "jobPostCard") {
              if (icon.props.name === "tag") {
                console.log("tag");
                console.log(
                  cardType === "jobPostCard" ? "jobPost" : null,
                  "is the type of card",
                );
                console.log(toJS(labels));
                LabelStore.setsection(
                  cardType === "jobPostCard" ? "jobPost" : null,
                );
                if (labels) {
                  const data = labels;
                  const ids = data.map((item) => item._id);
                  LabelStore.setApplicantLabelArray(ids);
                } else {
                  LabelStore.setApplicantLabelArray(labels);
                }
                LabelStore.setApplicantId(id);
                LabelStore.setApplicants(true);
                console.log("hello", toJS(labels));
                LabelStore.setsection(
                  cardType === "jobPostCard" ? "jobPost" : null,
                );
                console.log("this is the card type", cardType);
                LabelStore.setApplicantLabelArray(labels);
                LabelStore.setApplicantId(id);
                LabelStore.setApplicants(true);
              } else if (icon.props.name === "mail") {
                console.log("mail");
              } else if (icon.props.name === "menu") {
                console.log("menu");
              }
            }
          }}
        >
          {icon}
        </div>
      ))}
      <JobShare
        isPopupVisible={isPopupVisible}
        handlePopUpVisible={handlePopUpVisible}
        link={handleLink()}
        typeOfCard={typeOfCard}
      />
      <Menu
        anchorEl={anchorEl}
        cardType={cardType}
        status={status}
        open={show}
        handleStatus={handleStatus}
        onClose={() => setShow(false)}
        handleView={() => {
          handleNavigation();
          setShow(false);
        }}
        handleSort={handleSort}
        sorted={!job?.isSortingCompleted}
        handleDetails={handleDetailsNavigation}
        handleDelete={handleDelete}
        handleEdit={() => {
          editJobPost();
          setShow(false);
        }}
      />
      {/* {moreSettings===id &&<DropdownMenu/>} */}

      <JobShare
        isPopupVisible={isPopupVisible}
        handlePopUpVisible={handlePopUpVisible}
        link={handleLink()}
        typeOfCard={typeOfCard}
      />
    </div>
  ));
};

const HistoryJobpostCard = ({
  jobpost,
  label,
  job,
  buttonLabels,
  Elements,
  cardType,
  active,
  interviewType,
  interviewLevel,
  questions,
  postedOn,
  status,
  workMode,
  experience,
  salary,
  cutOff,
  onClick,
  handleNavigation,
  labels,
  id,
  totalApplicants,
  hold,
  rejected,
  shortlisted,
  hired,
  verifiedStatus,
}) => {
  const [isPopupVisible, setIsPopUpVisible] = useState(false);
  const { LabelStore } = useStores();
  const data = [
    {
      color: "#8F7EED",
      name: `${window.innerWidth < 600 ? "" : "Total"} Applicants`,
      value: totalApplicants == null ? "-" : totalApplicants,
    },

    // {
    //   color: "#FFB82B",
    //   name: "On Hold",
    //   value: !hold ? "-" : hold,
    // },
    {
      color: "#FFB82B",
      name: `${cardType === "jobPostCard" ? "Shortlisted" : "Qualified"}`,
      value: shortlisted ?? 0,
    },
    ...(cardType === "jobPostCard"
      ? [
          {
            color: "#20BF55",
            name: "Hired",
            value: hired ?? 0,
          },
        ]
      : []),
    {
      color: "#F63333",
      name: "Rejected",
      value: rejected ?? 0,
    },
  ];
  // const data2 = [
  //   {
  //     color: "#8F7EED",
  //     name: `${window.innerWidth < 600 ? "" : "Total"} Applicants`,
  //     value: job?.resumes?.length ?? 0,
  //   },
  //   {
  //     color: "#20BF55",
  //     name: "Shortlisted",
  //     value: job?.shortListed?.length ?? 0,
  //   },
  //   {
  //     color: "#FFB82B",
  //     name: `above 80%`,
  //     value: job?.resumesCountAbove80 ?? 0,
  //   },

  //   {
  //     color: "#F63333",
  //     name: "Rejected",
  //     value: job?.rejected?.length ?? 0,
  //   },
  // ];
  const data2 = [
    {
      color: "#8F7EED",
      name: `${window.innerWidth < 600 ? "" : "Total"} Resumes`,
      value: job?.resumes?.length ?? 0,
    },
    {
      color: "#20BF55",
      name: "Resume Above 80%",
      value: job?.shortListed?.length ?? 0,
    },

    {
      color: "#F63333",
      name: "Rejected Resumes",
      value: job?.rejected?.length ?? 0,
    },
  ];

  return (
    <div>
      <div
        className="md:h-[24vh] lg:h-[20.5vh] md:w-[100%] hidden md:flex items-center rounded-md my-5 "
        style={{ boxShadow: "0px 0px 60px 0px rgba(0, 0, 0, 0.1)" }}
      >
        <span className="flex flex-col items-center justify-center min-w-fit gap-2  mx-2">
          <img
            src={JSON.parse(localStorage.getItem("user"))?.pic || smallLogo}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = smallLogo;
            }}
            className="h-32 w-32 mx-5 rounded-full object-cover"
            alt=""
          />
        </span>
        <div className="flex flex-col justify-center gap-1 h-full my-9 flex-1 min-w-0">
          <div className="flex flex-row items-start">
            <div className="flex flex-col w-[50%] min-w-[300px]">
              <h1 className="whitespace-normal font-semibold md:text-xl lg:text-lg text-base text-[#1C1C1C]">
                {label}
              </h1>
              {cardType === "resumeCard" && (
                <h1 className="whitespace-nowrap font-medium">
                  {job?.name?.length > 0 ? job?.name : job?._id}{" "}
                  {job?.isSortingCompleted ? (
                    <span className="text-[#FF6B00]">(sorted)</span>
                  ) : (
                    <span className="text-[#FF6B00]">(saved)</span>
                  )}
                </h1>
              )}
              <h1 className="text-[#B5AEAE] text-base md:text-lg lg:text-lg ">
                {JSON.parse(localStorage.getItem("user"))?.companyName?.length >
                10
                  ? `${JSON.parse(
                      localStorage.getItem("user"),
                    )?.companyName?.substring(0, 10)}...`
                  : JSON.parse(localStorage.getItem("user"))?.companyName || ""}
              </h1>
            </div>
            {cardType !== "resumeCard" && (
              <StatusAndButtons
                status={status}
                verifiedStatus={verifiedStatus}
                buttonLabels={buttonLabels}
              />
            )}
          </div>
          <h1 className="text-orange-500 text-[10px]">ID:{id ?? "-"}</h1>
          <JobDetails
            Elements={Elements}
            interviewType={interviewType}
            interviewLevel={interviewLevel}
            questions={questions}
            postedOn={postedOn}
            cardType={cardType}
            label={label}
            workMode={workMode}
            experience={experience}
            salary={salary}
            cutOff={cutOff}
            job={job}
          />
          <div className="flex flex-row gap-5 w-[700px] ">
            {cardType !== "resumeCard" &&
              data.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row  md:gap-2 items-center text-sm"
                >
                  <div
                    className="w-3 h-3 rounded-sm break-words"
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <h1 className="text-[#555353] min-w-fit ">{item.name}:</h1>
                  <h1>{item.value}</h1>
                </div>
              ))}
            {cardType === "resumeCard" &&
              data2.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row items-center gap-1 text-sm"
                >
                  <div
                    className="w-3 h-3 rounded-sm "
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <h1 className="text-[#969696] min-w-fit  ">{item.name}:</h1>
                  <h1>{item.value}</h1>
                </div>
              ))}
            {/* <h1 className="text-[0.7rem] text-primary">ID:{id ?? "-"}</h1> */}
          </div>
        </div>

        {/* <App1 /> */}

        <div className="flex md:flex-col w-fit pr-5 h-[77%] justify-between items-end mb-6 pt-8 ">
          {/* <h1 className="mr-5">id:{id}</h1> */}

          <IconButtons
            onClick={onClick}
            cardType={cardType}
            job={job}
            id={id}
            labels={labels}
            status={status}
            label={label}
            handleNavigation={handleNavigation}
          />
          <div className="pb-5 pr-4">
            <button
              className="bg-[#000000] rounded-md whitespace-nowrap px-4 md:mb-1 max-h-10 w-[10rem] py-1 md:mr-6 flex items-center justify-center"
              onClick={handleNavigation}
            >
              <p className="white-space-nowrap text-sm flex text-[#F4EEE4]">
                View {cardType === "resumeCard" ? "Resumes" : "Applicants"}
              </p>
              &nbsp;
              <div>
                <IoIosArrowDropright className="text-base text-[#F4EEE4]" />
              </div>
            </button>
          </div>

          {LabelStore.Applicants && <ApplicantLabelPopup />}

          {/* <div className="flex gap-4 ">
          <FiMail className="border rounded-md  text-[30px] p-[5px] border-[#ff6b00]" />
          <AiOutlineShareAlt className="border rounded-md  text-[30px] p-[5px] border-[#ff6b00]" />
          <AiOutlineTag className="border rounded-md  text-[30px] p-[5px] border-[#ff6b00]" />
          <RxDotsHorizontal className="border rounded-md  text-[30px] p-[5px] border-[#ff6b00]" />
        </div> */}
        </div>
      </div>
      <div
        className=" md:w-[100%] lg:w-[100%] w-[100%]   relative md:hidden my-2 p-4 md:p-0 flex flex-col gap-4 items-center  py-5 rounded-md  text-sm"
        style={{ boxShadow: "0px 0px 60px 0px rgba(0, 0, 0, 0.1)" }}
        // onClick={handleNavigation}
      >
        <div className="flex flex-col justify-center gap-4 h-full w-full">
          <div className="flex flex-row items-center">
            <span className="flex flex-col items-center justify-center min-w-fit gap-2">
              <img
                src={JSON.parse(localStorage.getItem("user"))?.pic || smallLogo}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = smallLogo;
                }}
                className="h-16 w-16 rounded-full object-cover"
                alt=""
              />
            </span>
            <div className="flex flex-col gap-1 ml-2 w-full">
              <span className="flex flex-row items-center w-full gap-1 justify-between">
                {cardType !== "resumeCard" && (
                  <h1 className="whitespace-normal break-words font-semibold text-xl max-w-full">
                    {label}
                  </h1>
                )}
                {cardType === "resumeCard" && (
                  <h1 className="whitespace-normal break-words font-semibold text-xl max-w-full">
                    {job?.name?.length > 0 ? job?.name : job?._id}{" "}
                    {job?.isSortingCompleted ? (
                      <span className="text-[#FF6B00]">(sorted)</span>
                    ) : (
                      <span className="text-[#FF6B00]">(saved)</span>
                    )}
                  </h1>
                )}
              </span>
              <span className="flex flex-row items-center gap-4">
                <h1 className="text-gray-400">
                  {JSON.parse(localStorage.getItem("user"))?.companyName
                    ?.length > 10
                    ? `${JSON.parse(
                        localStorage.getItem("user"),
                      )?.companyName?.substring(0, 10)}...`
                    : JSON.parse(localStorage.getItem("user"))?.companyName ||
                      ""}
                </h1>
                {cardType !== "resumeCard" && (
                  <StatusAndButtons
                    status={status}
                    verifiedStatus={verifiedStatus}
                    buttonLabels={buttonLabels}
                  />
                )}
              </span>
              <h1 className="text-orange-500 text-[10px]">ID:{id ?? "-"}</h1>
            </div>
          </div>

          <JobDetails
            Elements={Elements}
            interviewType={interviewType}
            interviewLevel={interviewLevel}
            questions={questions}
            postedOn={postedOn}
            cardType={cardType}
            label={label}
            workMode={workMode}
            experience={experience}
            salary={salary}
            cutOff={cutOff}
            job={job}
          />

          <div className="flex flex-wrap gap-x-2 md:w-[700px] whitespace-normal break-words">
            {cardType !== "resumeCard" &&
              data.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row items-center text-sm my-2"
                >
                  <div
                    className="w-3 h-3 rounded-sm"
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <h1 className="text-[#969696] min-w-fit pl-2">
                    {item.name}:
                  </h1>
                  <h1 className="max-w-full break-words">{item.value}</h1>
                </div>
              ))}
            {cardType === "resumeCard" &&
              data2.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row items-center gap-1 text-sm"
                >
                  <div
                    className="w-3 h-3 rounded-sm "
                    style={{ backgroundColor: item.color }}
                  ></div>
                  <h1 className="text-[#969696] min-w-fit  ">{item.name}:</h1>
                  <h1>{item.value}</h1>
                </div>
              ))}
          </div>
        </div>

        <div className="text-gray-500 flex w-full h-auto min-h-full overflow-y-auto justify-between items-start gap-10">
          <button
            className="bg-black text-white rounded-md px-2 md:px-4 h-7 md:h-10 w-28 md:w-[10rem] py-1 flex items-center justify-evenly"
            onClick={handleNavigation}
          >
            <p className="whitespace-nowrap text-[10px] md:text-sm">
              View {cardType === "resumeCard" ? "Resumes" : "Applicants"}
            </p>
            <div>
              <IoIosArrowDropright />
            </div>
          </button>
          <div className="absolute right-0">
            <IconButtons
              onClick={onClick}
              cardType={cardType}
              id={id}
              labels={labels}
              label={label}
              handleNavigation={handleNavigation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryJobpostCard;
